import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "en",
    supportedLngs: ["en", "tr"],
    ns: [
      "common",
      "chat",
      "auth",
      "ticket",
      "request",
      "agent",
      "nav",
      "category",
      "subcategory",
      "group",
      "client",
      "workShift",
      "reports",
      "clientGroup",
      "updateReason",
      "knowledgeBase",
      "companySetting",
      "company",
      "dashboard",
      "auditLog",
      "temporalActivity",
      "ttsUsage",
    ],
    defaultNS: "common",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
